// Import package from Soil plugin example.
import $ from "@modules/jquery";

$(function() {
    //
});

let resizeTimeout;
const blocks = ["#block_services", "#block_vacancies", "#block_listings", "#block_cursus"];

function debounceEqualizeHeight() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        blocks.forEach(block => {
            equalizeHeight(`${block} .card-section`);
        });
    }, 100);
}

function equalizeHeight(container) {
    const elements = $(container).toArray();
    const rowMap = new Map();

    elements.forEach((el) => {
        el.style.height = "auto";
        const top = el.offsetTop;
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(el);
    });

    rowMap.forEach((rowElements) => {
        const maxHeight = Math.max(...rowElements.map((el) => el.clientHeight));
        rowElements.forEach((el) => (el.style.height = `${maxHeight}px`));
    });
}

// Livewire event listener
document.addEventListener("livewire:update", debounceEqualizeHeight);
window.addEventListener("filtered-updated", debounceEqualizeHeight);

window.addEventListener('livewire:pagination', (event) => {
    const [payload] = event.__livewire.params || [];
    const { page, pageName, state } = payload || {};

    if (state === 'updated') {
        // Delay the equalizeHeight call with setTimeout (e.g., 500ms delay)
        setTimeout(() => {
            equalizeHeight("#block_services .card-section");
            debounceEqualizeHeight();
            console.log("Pagination event:", state);
        }, 1000);
    }

    if (page && pageName && state) {
        // Delay the debounceEqualizeHeight call with setTimeout
        setTimeout(() => {
            debounceEqualizeHeight();
        }, 1000);
    } else {
        console.error("Pagination event missing required data:", payload);
    }
});



$(document).ready(function () {
    blocks.forEach(block => {
        const livewireGrid = document.querySelector(block);
        if ($(window).width() > 600 && livewireGrid !== null) {
            //console.log("Livewire Grid Found:", livewireGrid);

            const observer = new MutationObserver(function (mutations) {
                let shouldUpdate = false;

                mutations.forEach((mutation) => {
                    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                        shouldUpdate = true;
                    }
                });

                if (shouldUpdate) {
                    debounceEqualizeHeight();
                }
            });

            observer.observe(livewireGrid, {
                childList: true,
                subtree: true,
            });
        }
    });
});

$(window).resize(() => {
    if ($(window).width() > 600) {
        debounceEqualizeHeight();
    }
});